let deferredPrompt = null;
let cleanup = null;
const listeners = new Set();
const initialState = { canInstall: false, isInstalled: false, isStandalone: false, installing: false };
let state = initialState;

function update(changes) {
  state = { ...state, ...changes };
  listeners.forEach((listener) => listener());
}

export const getInstallState = () => state;
export function subscribeToInstall(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// Start before React renders so route changes cannot lose the browser's event.
export function initializeInstall() {
  if (cleanup) return cleanup;
  const displayMode = window.matchMedia?.('(display-mode: standalone)');
  const updateDisplayMode = () => update({
    isStandalone: !!displayMode?.matches || window.navigator.standalone === true,
  });
  const onPrompt = (event) => {
    event.preventDefault();
    if (state.isInstalled || state.isStandalone) return;
    deferredPrompt = event;
    update({ canInstall: true });
  };
  const onInstalled = () => {
    deferredPrompt = null;
    update({ canInstall: false, isInstalled: true });
  };
  updateDisplayMode();
  window.addEventListener('beforeinstallprompt', onPrompt);
  window.addEventListener('appinstalled', onInstalled);
  displayMode?.addEventListener('change', updateDisplayMode);
  cleanup = () => {
    window.removeEventListener('beforeinstallprompt', onPrompt);
    window.removeEventListener('appinstalled', onInstalled);
    displayMode?.removeEventListener('change', updateDisplayMode);
    deferredPrompt = null;
    cleanup = null;
    state = initialState;
  };
  return cleanup;
}

export async function promptInstall() {
  if (state.installing) return { outcome: 'busy' };
  if (!deferredPrompt || state.isInstalled || state.isStandalone) return { outcome: 'unavailable' };
  const prompt = deferredPrompt;
  deferredPrompt = null;
  update({ canInstall: false, installing: true });
  try {
    // Call synchronously within the click gesture. Each event is single-use.
    const choice = await prompt.prompt();
    return choice || await prompt.userChoice;
  } finally {
    update({ installing: false });
  }
}
